// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lw-0";
export var fileList = "_lw-2";
export var removeFileButton = "_lw-1";